export const FLAGS = {
	NOTIFICATIONS: 'REACT_APP_DISABLE_NOTIFICATIONS',
	JOBS: 'REACT_APP_DISABLE_JOBS',
	SEQUENCES: 'REACT_APP_DISABLE_SEQUENCES',
	DISABLE_DEBUG_LOGS: 'REACT_APP_DISABLE_DEBUG_LOGS',
};

export const getEnvFlag = (flag: string = ''): string | void => {
	return process.env[flag] || void 0;
};

export const isFlagEnabled = (flag: string = '') => {
	const env = getEnvFlag(flag) || 'false';
	return !!(env === 'true');
};

export const areJobsDisabled = isFlagEnabled(FLAGS.JOBS);
export const areNotificationsDisabled = isFlagEnabled(FLAGS.NOTIFICATIONS);
export const areSequencesDisabled = isFlagEnabled(FLAGS.SEQUENCES);
export const areDebugLogsDisabled = isFlagEnabled(FLAGS.DISABLE_DEBUG_LOGS);
